import React from "react"
import { HStack, Text } from "@chakra-ui/react"
import GuestListIcon from "./GuestListIcon"

type Props = {
  title: string
  icon: string | null
  color?: string | null
  compact?: boolean
}

const EventGroupItem = ({
  icon, color, title, compact = false,
}: Props) => {
  const textProps = compact
    ? {
      fontSize: "sm" as const,
      whiteSpace: "nowrap" as const,
      overflow: "hidden" as const,
      textOverflow: "ellipsis" as const,
    }
    : {
      whiteSpace: "normal" as const,
      noOfLines: 1,
    }

  return (
    <HStack
      gap={compact ? 1 : 2}
      align="center"
      {...(compact && { overflow: "hidden", minW: 0 })}
    >
      <GuestListIcon
        icon={icon}
        color={color}
        boxSize={compact ? 3 : 5}
        flexShrink={0}
      />
      <Text {...textProps}>{title}</Text>
    </HStack>
  )
}

export default EventGroupItem
